<template>
    <div v-if="props.value && props.value.logo">
        <img :src="props.value.logo" :alt="props.value.name" class="object-center w-20 h-10 object-fit" />
    </div>
    <div v-else-if="props.value && props.value.name">
        <span class="font-bold">{{ props.value.name }}</span>
    </div>
</template>

<script setup lang="ts">
import type { GridComponent } from '@src/Common/Components/types';

const props = withDefaults(defineProps<GridComponent>(), {});
</script>
